/** Section keys used in StaffMovements conditional rendering */
export const STAFF_MOVEMENT_SECTIONS = {
    /** Single date — "За период" */
    FOR_PERIOD: 'forPeriod',
    /** Date range — "От дата" / "До дата" */
    FROM_TO: 'fromTo',
    LANGUAGE_COMPANY: 'languageCompany',
    FOR_PEOPLE: 'forPeople',
    ADDITIONAL_COLUMNS: 'additionalColumns',
};
export const STAFF_MOVEMENT_OPTION_KEYS = [
    { value: 'option-1', labelKey: 'staff.staffMovement.options.generalHrMovementByCompanies' },
    { value: 'option-2', labelKey: 'staff.staffMovement.options.detailedHrMovementByCompanies' },
    { value: 'option-3', labelKey: 'staff.staffMovement.options.hrCollect' },
    { value: 'option-4', labelKey: 'staff.staffMovement.options.dismissedEmployees' },
    { value: 'option-5', labelKey: 'staff.staffMovement.options.salariesAndBonuses' },
    { value: 'option-6', labelKey: 'staff.staffMovement.options.historyOfSalaryChanges' },
    { value: 'option-7', labelKey: 'staff.staffMovement.options.daysWorkedForPeriod' },
    { value: 'option-8', labelKey: 'staff.staffMovement.options.employeesUnderNssiThresholds' },
    { value: 'option-9', labelKey: 'staff.staffMovement.options.maximumSalariesLast5Years' },
    { value: 'option-10', labelKey: 'staff.staffMovement.options.grossSalariesForPeriod' },
    { value: 'option-11', labelKey: 'staff.staffMovement.options.grossSalariesWithBonuses' },
    { value: 'option-12', labelKey: 'staff.staffMovement.options.occupationalHealthServices' },
    { value: 'option-13', labelKey: 'staff.staffMovement.options.probationaryPeriodContracts' },
    { value: 'option-14', labelKey: 'staff.staffMovement.options.mandatoryAbsenceMonitoring' },
    { value: 'option-15', labelKey: 'staff.staffMovement.options.termContracts' },
    { value: 'option-16', labelKey: 'staff.staffMovement.options.employeeStructureInformation' },
    { value: 'option-17', labelKey: 'staff.staffMovement.options.basicEmployeeInformation' },
    { value: 'option-18', labelKey: 'staff.staffMovement.options.investmentServicesSeller' },
    { value: 'option-19', labelKey: 'staff.staffMovement.options.insuranceBrokerEmployee' },
];

export const STAFF_MOVEMENT_LANGUAGE_OPTIONS = [
    { value: 'en-US', labelKey: 'staff.staffMovement.languages.englishUsa' },
    { value: 'bg-BG', labelKey: 'staff.staffMovement.languages.bulgarianBulgaria' },
];

export const STAFF_MOVEMENT_PEOPLE_STATUS_OPTION_SETS = {
    ALL: 'all',
    TERMINATED_WORKING: 'terminatedWorking',
};

export const STAFF_MOVEMENT_PEOPLE_STATUS_OPTIONS_ALL = [
    { value: 'appointed', labelKey: 'staff.staffMovement.peopleStatus.appointedDuringPeriod' },
    { value: 'terminated', labelKey: 'staff.staffMovement.peopleStatus.terminatedDuringPeriod' },
    { value: 'working', labelKey: 'staff.staffMovement.peopleStatus.workingDuringPeriod' },
];

export const STAFF_MOVEMENT_PEOPLE_STATUS_OPTIONS_TERMINATED_WORKING = [
    { value: 'terminated', labelKey: 'staff.staffMovement.peopleStatus.terminatedDuringPeriod' },
    { value: 'working', labelKey: 'staff.staffMovement.peopleStatus.workingDuringPeriod' },
];

const PEOPLE_STATUS_OPTIONS_BY_SET = {
    [STAFF_MOVEMENT_PEOPLE_STATUS_OPTION_SETS.ALL]: STAFF_MOVEMENT_PEOPLE_STATUS_OPTIONS_ALL,
    [STAFF_MOVEMENT_PEOPLE_STATUS_OPTION_SETS.TERMINATED_WORKING]:
        STAFF_MOVEMENT_PEOPLE_STATUS_OPTIONS_TERMINATED_WORKING,
};

/** Which FOR_PEOPLE radio set each report uses */
export const STAFF_MOVEMENT_PEOPLE_STATUS_SET_BY_REPORT = {
    'option-12': STAFF_MOVEMENT_PEOPLE_STATUS_OPTION_SETS.ALL,
    'option-18': STAFF_MOVEMENT_PEOPLE_STATUS_OPTION_SETS.TERMINATED_WORKING,
    'option-19': STAFF_MOVEMENT_PEOPLE_STATUS_OPTION_SETS.TERMINATED_WORKING,
};

/** Placeholder until companies API is wired */
export const STAFF_MOVEMENT_COMPANY_OPTIONS = [];

const S = STAFF_MOVEMENT_SECTIONS;

/** Reusable section groups — compose into STAFF_MOVEMENT_SECTIONS_BY_TYPE */
export const FOR_PERIOD_ONLY = [S.FOR_PERIOD];
export const FOR_PERIOD_LANGUAGE_COMPANY = [S.FOR_PERIOD, S.LANGUAGE_COMPANY];
export const FROM_TO_ONLY = [S.FROM_TO];
export const FROM_TO_LANGUAGE_COMPANY = [S.FROM_TO, S.LANGUAGE_COMPANY];
export const FROM_TO_LANGUAGE_COMPANY_FOR_PEOPLE = [...FROM_TO_LANGUAGE_COMPANY, S.FOR_PEOPLE];
export const FOR_PERIOD_LANGUAGE_COMPANY_ADDITIONAL_COLUMNS = [
    ...FOR_PERIOD_LANGUAGE_COMPANY,
    S.ADDITIONAL_COLUMNS,
];

/** Visible sections per report type — extend as you add more reports */
export const STAFF_MOVEMENT_SECTIONS_BY_TYPE = {
    'option-1': FOR_PERIOD_LANGUAGE_COMPANY,
    'option-2': FOR_PERIOD_LANGUAGE_COMPANY,
    'option-3': FROM_TO_LANGUAGE_COMPANY,
    'option-4': FROM_TO_LANGUAGE_COMPANY, //✅
    'option-5': FOR_PERIOD_LANGUAGE_COMPANY,//✅
    'option-6': FOR_PERIOD_LANGUAGE_COMPANY,
    'option-7': FROM_TO_LANGUAGE_COMPANY,
    'option-8': FOR_PERIOD_LANGUAGE_COMPANY,
    'option-9': FOR_PERIOD_LANGUAGE_COMPANY,
    'option-10': FROM_TO_LANGUAGE_COMPANY,
    'option-11': FROM_TO_LANGUAGE_COMPANY,
    'option-12': FROM_TO_LANGUAGE_COMPANY_FOR_PEOPLE,
    'option-13': FOR_PERIOD_LANGUAGE_COMPANY,
    'option-14': FOR_PERIOD_LANGUAGE_COMPANY,
    'option-15': FROM_TO_LANGUAGE_COMPANY,
    'option-16': FOR_PERIOD_LANGUAGE_COMPANY,
    'option-17': FOR_PERIOD_LANGUAGE_COMPANY_ADDITIONAL_COLUMNS,
    'option-18': FROM_TO_LANGUAGE_COMPANY_FOR_PEOPLE,
    'option-19': FROM_TO_LANGUAGE_COMPANY_FOR_PEOPLE,

};
export function getStaffMovementOptions(t) {
    return STAFF_MOVEMENT_OPTION_KEYS.map(({ value, labelKey }) => ({
        value,
        label: t(labelKey),
    }));
}

export function getStaffMovementLanguageOptions(t) {
    return STAFF_MOVEMENT_LANGUAGE_OPTIONS.map(({ value, labelKey }) => ({
        value,
        label: t(labelKey),
    }));
}

export function getStaffMovementPeopleStatusOptions(t, reportKey = '') {
    const setKey = STAFF_MOVEMENT_PEOPLE_STATUS_SET_BY_REPORT[reportKey]
        ?? STAFF_MOVEMENT_PEOPLE_STATUS_OPTION_SETS.ALL;
    const options = PEOPLE_STATUS_OPTIONS_BY_SET[setKey] ?? STAFF_MOVEMENT_PEOPLE_STATUS_OPTIONS_ALL;

    return options.map(({ value, labelKey }) => ({
        value,
        label: t(labelKey),
    }));
}

export function getDefaultPeopleStatus(reportKey = '') {
    const setKey = STAFF_MOVEMENT_PEOPLE_STATUS_SET_BY_REPORT[reportKey]
        ?? STAFF_MOVEMENT_PEOPLE_STATUS_OPTION_SETS.ALL;
    const options = PEOPLE_STATUS_OPTIONS_BY_SET[setKey] ?? STAFF_MOVEMENT_PEOPLE_STATUS_OPTIONS_ALL;

    if (options.some((option) => option.value === 'working')) {
        return 'working';
    }

    return options[0]?.value ?? 'working';
}

export function getVisibleSections(reportKey) {
    return STAFF_MOVEMENT_SECTIONS_BY_TYPE[reportKey] ?? [];
}

export function isSectionVisible(reportKey, sectionKey) {
    return getVisibleSections(reportKey).includes(sectionKey);
}
